<div class="agenda-confirm-modal-container">
    <button class="close-icon" (click)="onClose()" aria-label="Cerrar">&times;</button>
    <h2 class="confirm-dialog-title">
        {{ data.title || 'Confirmación de servicio' }}
    </h2>
    <div class="messages-list">
        <div *ngFor="let msg of data.messages" class="confirm-message">{{ msg }}</div>
    </div>
    <div class="actions">
        <button mat-button class="confirm-button" (click)="onConfirm()">
            {{ data.confirmText || 'Aceptar y crear' }}
        </button>
        <button mat-button class="cancel-button" (click)="onClose()">
            {{ data.cancelText || 'Cancelar' }}
        </button>
    </div>
</div>